import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },

  icon: {
    width: '0.75rem',
    height: '0.75rem',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    marginRight: '0.5rem'
  }
}))

export default useStyles
